import { FC } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { Toast, ToastProps } from '@shared/components/toast';
import { AlertRoundIcon } from '@shared/icons/alert-round';
import { PusherKeyUser, PusherPayload } from '@shared/types/common/events';

import { styles } from '../bulk-action-completed-toast/BulkActionCompletedToast.styles';

export interface BulkActionFailureToastProps
  extends Omit<ToastProps, 'classes'>,
    Omit<PusherPayload[PusherKeyUser.BulkActionFailure], 'job_id' | 'type'>,
    WithStyles<typeof styles> {
  onClickLink: (link: string) => void;
}

const BulkActionFailureToastComponent: FC<BulkActionFailureToastProps> = ({
  classes,
  failed_text,
  subtext,
  title,
  url,
  url_text,
  onClickLink,
  onClose,
}) => {
  return (
    <Toast classes={{ root: classes.root }} title={title} onClose={onClose}>
      <div className={classes.content}>
        <span className={classes.message}>{subtext}</span>
        <div className={classes.resultWrapper}>
          {!!failed_text && (
            <div className={classes.row}>
              <AlertRoundIcon />
              <span className={classes.message}>{failed_text}</span>
            </div>
          )}
          {!!(url && url_text) && (
            <div className={classes.row}>
              <span
                className={classes.failedLink}
                onClick={() => {
                  onClickLink(url);
                  onClose();
                }}
              >
                {url_text}
              </span>
            </div>
          )}
        </div>
      </div>
    </Toast>
  );
};

export const BulkActionFailureToast = withStyles(styles)(BulkActionFailureToastComponent);
